var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35809 3.93871L5.79766 11.6974L6.52476 12.0311L10.0852 4.27237L9.35809 3.93871Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84666 7.7599C5.00999 7.7599 4.35666 6.9199 4.35666 5.85323C4.35666 4.78656 5.02333 3.94656 5.84666 3.94656C6.66999 3.94656 7.33333 4.78323 7.33333 5.85323C7.33333 6.92323 6.66666 7.7599 5.84666 7.7599ZM5.15666 5.86656C5.15666 5.27656 5.47999 4.7599 5.84666 4.7599V4.74656C6.20999 4.74656 6.53333 5.2799 6.53333 5.86656C6.53333 6.45323 6.20333 6.97323 5.84666 6.97323C5.48999 6.97323 5.15666 6.45656 5.15666 5.86656Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.08 11.9999C9.24666 11.9999 8.59333 11.1599 8.59333 10.0932C8.59333 9.02656 9.25999 8.18656 10.08 8.18656C10.9 8.18656 11.57 9.02323 11.57 10.0932C11.57 11.1632 10.9133 11.9999 10.08 11.9999ZM9.39333 10.1066C9.39333 9.51656 9.71333 8.9999 10.08 8.9999C10.4467 8.9999 10.7667 9.51656 10.7667 10.1066C10.7667 10.6966 10.4333 11.2132 10.08 11.2132C9.72666 11.2132 9.39333 10.6966 9.39333 10.1066Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 14.7499C4.48333 14.7499 1.62 11.7166 1.62 7.9999C1.62 4.28323 4.48333 1.22656 7.99999 1.22656C11.5167 1.22656 14.38 4.2599 14.38 7.9999C14.38 11.7399 11.5167 14.7499 7.99999 14.7499ZM7.99999 2.02656C4.92333 2.02656 2.42 4.69323 2.42 7.9899C2.42 11.2866 4.92333 13.9499 7.99999 13.9499C11.0767 13.9499 13.58 11.2832 13.58 7.9899C13.58 4.69656 11.0767 2.02656 7.99999 2.02656Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo);
export default __webpack_public_path__ + "static/media/promo.ea5392eee550941d866a7bdbb1eba008.svg";
export { ForwardRef as ReactComponent };